/**
 * Rarity → gem asset name.
 *
 * A verbatim mirror of `RARITY_EMOJIS` in `types/util/emojis.js`, which is
 * where the bot resolves the same names to Discord application emojis. Both
 * sides point at the same five files from the Gems icon set, so a legendary
 * drop looks identical whether you see it in a channel or on your profile.
 *
 * Duplicated rather than imported: the SPA is a separate npm project with its
 * own lockfile, and `types/util/emojis.js` uses optional chaining, which this
 * project's webpack 4 / vue-cli 4 build cannot parse. `tests/rarityGems.test.js`
 * fails if the two ever disagree — see tests/rewardsMirror.test.js for how a
 * "keep this in sync" comment worked out last time.
 */
export const RARITY_EMOJIS = Object.freeze({
    mythical: 'gem2_color1',
    legendary: 'gem5_color4',
    epic: 'gem8_color5',
    rare: 'gem8_color1',
    common: 'gem6_color2',
})

/**
 * The asset name for a rarity, falling back to the rare gem.
 *
 * The fallback matters: a plain `item` reward on the season track carries no
 * rarity at all, and rendering nothing there would leave a hole in the card.
 */
export function gemNameForRarity(rarity) {
    return RARITY_EMOJIS[rarity] || RARITY_EMOJIS.rare
}
